// Active Units
export const FETCH_UNIT_ACTIVE_REQUEST = "FETCH_UNIT_ACTIVE_REQUEST";
export const FETCH_UNIT_ACTIVE_SUCCESS = "FETCH_UNIT_ACTIVE_SUCCESS";
export const FETCH_UNIT_ACTIVE_FAIL = "FETCH_UNIT_ACTIVE_FAIL";

// Inactive Units
export const FETCH_UNIT_INACTIVE_REQUEST = "FETCH_UNIT_INACTIVE_REQUEST";
export const FETCH_UNIT_INACTIVE_SUCCESS = "FETCH_UNIT_INACTIVE_SUCCESS";
export const FETCH_UNIT_INACTIVE_FAIL = "FETCH_UNIT_INACTIVE_FAIL";

// Add Unit
export const UNIT_ADD_REQUEST = "UNIT_ADD_REQUEST";
export const UNIT_ADD_SUCCESS = "UNIT_ADD_SUCCESS";
export const UNIT_ADD_FAIL = "UNIT_ADD_FAIL";

// Update Unit
export const UNIT_UPDATE_REQUEST = "UNIT_UPDATE_REQUEST";
export const UNIT_UPDATE_SUCCESS = "UNIT_UPDATE_SUCCESS";
export const UNIT_UPDATE_FAIL = "UNIT_UPDATE_FAIL";

// Get Unit By ID
export const FETCH_BY_ID_UNIT_REQUEST = "FETCH_BY_ID_UNIT_REQUEST";
export const FETCH_BY_ID_UNIT_SUCCESS = "FETCH_BY_ID_UNIT_SUCCESS";
export const FETCH_BY_ID_UNIT_FAIL = "FETCH_BY_ID_UNIT_FAIL";
